"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDisplayName = function (Component) {
    if (typeof Component === 'string') {
        return Component;
    }
    if (!Component) {
        return;
    }
    return Component.displayName || Component.name || 'Component';
};
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/hocs/utils.js
// module id = 500
// module chunks = 0